import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import settings from 'settings';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import ExtendeSelect from 'components/extendedSelect';

const mapStateToProps = state => ({
  inFlight: state.api[REDUCER_KEY.activityList.key].inFlight,
  collectionValues: state.api[REDUCER_KEY.activityList.key].data.results,
  themes: state.api.themes.data.results
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadActivityCollection(filters) {
    const sorted = ownProps.sorting ? ownProps.sorting : [];

    return dispatch(list([REDUCER_KEY.activityList.key], {
      page: 0,
      pageSize: settings.APP_CONFIG.dropListSize,
      filters,
      sorted
    }));
  },
  loadThemes(theme) {
    return dispatch(list(
      REDUCER_KEY.themes.key,
      {
        page: 0,
        pageSize: settings.APP_CONFIG.dropListSize,
        filters: [{
          id: 'model',
          value: theme
        }],
        sorted: [{
          id: 'model',
          desc: false
        }]
      }
    ));
  }
});

const activityOptionKey = item => item.id;
const activityOptionLabel = item => item.name;

class ActivitySelector extends Component {
  constructor(props) {
    super(props);

    this.handleActivityChange = this.handleActivityChange.bind(this);
    this.handleActivityChange = debounce(this.handleActivityChange, 100);

    this.loadActivity = this.loadActivity.bind(this);
  }

  componentDidMount() {
    this.loadActivity();
  }

  loadActivity(searchText = '') {
    const { theme, loadThemes, loadActivityCollection } = this.props;

    loadThemes(theme)
      .then((response) => {
        if (response && response.results.length) {
          const { id } = response.results[0];
          // ------ Set query the Filters ------
          const filters = [{
            id: 'collection__theme',
            value: id
          }];
          if (searchText) {
            filters.push({
              id: 'q',
              value: searchText
            }); // query the server query fields for a broad search
          }

          // ------ Load the Tags ------
          loadActivityCollection(filters);
        }
      });
  }

  handleActivityChange(value) {
    const { onChange } = this.props;

    onChange(value);
  }

  render() {
    const {
      collectionValues, inFlight, disabled, showSearch, dropdownMatchSelectWidth, placeholder, value, size, mode, maxTagCount, themes, labelInValue
    } = this.props;

    if (!themes.length) {
      return null;
    }

    return (
      <ExtendeSelect
        placeholder={placeholder}
        value={value}
        size={size}
        mode={mode}
        maxTagCount={maxTagCount}
        dataSource={collectionValues}
        optionKey={activityOptionKey}
        optionLabel={activityOptionLabel}
        onSearch={this.loadActivity}
        onFocus={this.loadActivity}
        onChange={this.handleActivityChange}
        showSearch={showSearch}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        disabled={disabled}
        fetching={inFlight}
        labelInValue={labelInValue}
      />
    );
  }
}

ActivitySelector.propTypes = {
  collectionValues: PropTypes.array,
  loadActivityCollection: PropTypes.func.isRequired,
  loadThemes: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  size: PropTypes.string,
  mode: PropTypes.string,
  maxTagCount: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  inFlight: PropTypes.bool,
  showSearch: PropTypes.bool,
  dropdownMatchSelectWidth: PropTypes.bool,
  themes: PropTypes.array,
  labelInValue: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  sorting: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.string, PropTypes.string)
  )
};

ActivitySelector.defaultProps = {
  collectionValues: [],
  placeholder: 'Select Activity',
  size: 'default',
  mode: 'multiple',
  maxTagCount: 3,
  showSearch: true,
  dropdownMatchSelectWidth: true,
  value: [],
  onChange() {
  },
  disabled: false,
  inFlight: false,
  themes: [],
  labelInValue: true,
  sorting: []
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySelector);
